import axios from 'axios';

export const getAdServers = async () => {
  const url = `${SERVICE_URL}/api/v1/ad-servers`;
  return axios.get(url).then((response) => response.data);
};
